import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

type CreateUserV2Path = paths['/v2/users']['post'];

type CreateUserV2Request = CreateUserV2Path['requestBody']['content']['application/json'];

type CreateUserV2Response = CreateUserV2Path['responses']['201']['content']['application/json'];

export type CreateUserV2ReferralExtras = {
  referredById?: number;
  referredByPrefix?: string;
  referredByName?: string;
};

export type CreateUserV2Result = CreateUserV2Response['data'] & CreateUserV2ReferralExtras;

export async function createUserV2(data: CreateUserV2Request): Promise<CreateUserV2Result> {
  const response = await fetchClient.POST('/v2/users', {
    body: data,
  });

  if (!response.data) {
    throw new Error('No response data received');
  }

  const referral = response.data.data?.referrer
    ? {
        referredById: response.data.data.referrer.id,
        referredByPrefix: 'Referred by',
        referredByName: `${response.data.data.referrer.firstName} ${response.data.data.referrer.lastName}`,
      }
    : {};

  return {
    ...response.data.data,
    ...referral,
  } as CreateUserV2Result;
}
